export default "__VITE_ASSET__DM50BxE3__"